module.exports = __webpack_public_path__ + "static/media/Ardaelal.7846a339.md";